module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-1-b746862b8938efad07335c4b5beef661.png";